
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { AddApplicationDialog } from "./AddApplicationDialog";
import { useState } from "react";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useIsMobile } from "@/hooks/use-mobile";

interface TeamApplicationHeaderProps {
  teamId: string | undefined;
  teams: { id: string; name: string }[] | undefined;
  onTeamChange: (selectedTeamId: string) => void;
  onAddApplication: (title: string, link: string, status: string) => Promise<void>;
}

export const TeamApplicationHeader = ({
  teamId,
  teams,
  onTeamChange,
  onAddApplication,
}: TeamApplicationHeaderProps) => {
  const { roles } = useUserRoles();
  const isMobile = useIsMobile();
  
  // Only show the add application button if the user is not a guard or client
  const canAddApplication = !['guard', 'client'].includes(roles?.[0] || '');

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 md:gap-0">
      <div className="space-y-1 md:space-y-2 w-full md:w-auto">
        <h1 className="text-xl md:text-2xl font-semibold text-secondary-800 dark:text-white">Work Applications</h1>
        <p className="text-sm md:text-base text-gray-500 dark:text-gray-300">View and manage team work applications</p>
      </div>
      <div className="flex items-center gap-2 md:gap-4 w-full md:w-auto">
        <Select value={teamId} onValueChange={onTeamChange}>
          <SelectTrigger className={isMobile ? "flex-1" : "w-[200px]"}>
            <SelectValue placeholder="Select Team" />
          </SelectTrigger>
          <SelectContent>
            {teams?.map((team) => (
              <SelectItem key={team.id} value={team.id}>
                {team.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {canAddApplication && <AddApplicationDialog onSubmit={onAddApplication} />}
      </div>
    </div>
  );
};
